import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import {sixDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const formatRUPostcode = (value) => {
  if (!value) return value;
  
  const trimmedValue = value.trim();
  const spacesRemoved = value.replace(/\s/g, '');
  
  return spacesRemoved.length === 6 && trimmedValue.includes(' ')
    ? `${spacesRemoved.slice(0, 3)} ${spacesRemoved.slice(3)}`
    : trimmedValue;
};

const FieldDefinitionRU = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatRUPostcode,
    maxLength: 6,
    validate: [required.postCode, max.lengthPostCode(6), sixDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  townCity,
  county,
];

export default FieldDefinitionRU;
